import { render, staticRenderFns } from "./ModalEliminar.vue?vue&type=template&id=e8680bdc"
import script from "./ModalEliminar.vue?vue&type=script&lang=js"
export * from "./ModalEliminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports